// チャット入力欄の「＋」から開くアクション定義（Web）。
//
// 並びは使用頻度順（画像 → ファイル → 質問）。管理者限定の質問を末尾に置くことで、
// 出演者では末尾の1件が消えるだけになり、他アクションの位置が動かない。
// ラベルは器で2組を使い分ける: 行の中は最短形(shortLabel)、読み上げ/tooltipは説明形(fullLabel)。
//
// 同じ定義を各PFで保つこと:
// - Mobile: mobile/src/screens/chat/chatComposerActions.js
// - macOS: macos/Casticart/Sources/Casticart/Views/MacChatComposerActionRow.swift

export const CHAT_COMPOSER_ACTION_IDS = {
  IMAGE: "image",
  FILE: "file",
  QUESTION: "question",
};

// 画像・ファイル・質問の順に、有効なものだけを返す。
export function buildChatComposerActions({
  canSelectImage = true,
  onSelectImage,
  onSelectFile,
  canCreateQuestion = false,
  onCreateQuestion,
  attachmentDisabled = false,
  questionDisabled = false,
} = {}) {
  const actions = [];

  if (canSelectImage) {
    actions.push({
      id: CHAT_COMPOSER_ACTION_IDS.IMAGE,
      icon: "fa-solid fa-image",
      shortLabel: "画像",
      fullLabel: "画像を選択（最大5枚）",
      disabled: attachmentDisabled,
      onSelect: onSelectImage,
    });
  }

  actions.push({
    id: CHAT_COMPOSER_ACTION_IDS.FILE,
    icon: "fa-solid fa-file",
    shortLabel: "ファイル",
    fullLabel: "ファイルを選択",
    disabled: attachmentDisabled,
    onSelect: onSelectFile,
  });

  if (canCreateQuestion) {
    actions.push({
      id: CHAT_COMPOSER_ACTION_IDS.QUESTION,
      icon: "fa-solid fa-circle-question",
      shortLabel: "質問",
      fullLabel: "質問メッセージを作成",
      disabled: questionDisabled,
      onSelect: onCreateQuestion,
    });
  }

  return actions;
}
